<template>
  <section id="section-meeting-details">
    <v-row class="row-meeting-details">
      <v-icon large class="icon-meeting-details">
        mdi-account
      </v-icon>
      <span class="span-meeting-details">{{ dataMeetingDetails.userName }}</span>
    </v-row>
    <v-row class="row-meeting-details">
      <v-icon large class="icon-meeting-details">
        mdi-clock-outline
      </v-icon>
      <span class="span-meeting-details">{{ bannerMeetingDuration }}</span>
    </v-row>
    <v-row class="row-meeting-details">
      <v-icon large class="icon-meeting-details">
        mdi-calendar-month-outline
      </v-icon>
      <span class="span-meeting-details">{{ dataMeetingDetails.bannerMeetingTime }}</span>
    </v-row>
    <v-row class="row-meeting-details">
      <v-icon large class="icon-meeting-details">
        mdi-web-clock
      </v-icon>
      <span class="span-meeting-details">{{ dataMeetingDetails.timeZoneLead }}</span>
    </v-row>
  </section>
</template>

<script>
  //import {mapGetters} from 'vuex';
  import moment from 'moment-timezone';
  import xlooLib from "../xlooLib/xlooLib";
  export default {
    name: "meetingDetails",
    data(){
      return {
        dataMeetingDetails: {
          userName: '',
          bannerMeetingDuration: null,
          bannerMeetingTime: null,
          timeZoneLead: null,
        },
      }
    },
    created() {
      this.dataMeetingDetails.userName = this.$store.getters.firstNameUser + ' ' + this.$store.getters.lastNameUser;
      this.bannerMeetingDuration = this.createBannerMeetingDuration();
      this.dataMeetingDetails.bannerMeetingTime = this.createBannerMeetingTime();
      this.dataMeetingDetails.timeZoneLead = this.$store.getters.timeZoneLeadBanner;
    },
    methods : {
      createBannerMeetingDuration(){
        let banner = "";
        const hours = Math.trunc(this.$store.getters.meetingDuration/60);
        const minutes = this.$store.getters.meetingDuration - 60*hours;
        if(hours>1) banner = hours + " Hours ";
          else if(hours===1) banner = hours + " Hour ";
        if(minutes>1) banner = banner + minutes + " Minutes";
          else if(minutes===1) banner = banner + minutes + " Minute";
        return banner;
      },
      createBannerMeetingTime(){
        let dataMeeting = xlooLib.dateOfTimeZone(
            moment(this.$store.getters.dateBooking).format('YYYY'),
            moment(this.$store.getters.dateBooking).format('MM'),
            moment(this.$store.getters.dateBooking).format('DD'),
            moment(this.$store.getters.dateBooking).format('HH:mm'),
            this.$store.getters.timeZoneLead
        )
        console.log('npo tz ->', dataMeeting);
        console.log('user-->', moment(this.$store.getters.dateBooking).utcOffset(this.$store.getters.timeZoneLead).format("h:mm A"))
//        console.log('tz-->', moment.tz(this.$store.getters.dateBooking, this.$store.getters.timeZoneLead).format('DD/MM/YYYY HH:mm'))
//        console.log('dateBooking meeting details-->', this.$store.getters.dateBooking, dataMeeting, moment().utc(dataMeeting).utcOffset(this.$store.getters.timeZoneLead).format("h:mm A"));

        return moment(this.$store.getters.dateBooking).utcOffset(this.$store.getters.timeZoneLead).format("h:mm A") + " - " +
          moment(this.$store.getters.dateBooking).utcOffset(this.$store.getters.timeZoneLead).add(this.$store.getters.meetingDuration,"m").format("h:mm A") + ", " +
          moment(this.$store.getters.dateBooking).format("MMMM Do YYYY");
      },
    }
  }
</script>

<style scoped>
  #section-meeting-details{
    margin-top: 32px;
    padding: 0 15px;
  }
  .row-meeting-details{
    align-items: center;
    margin-bottom: 20px;
  }

  .span-meeting-details{
    color: rgba(0,0,0,.87);
  }

</style>
